/**
 * BrandArrowIcon — стрелка из лого ShiftGears (та же геометрия что в
 * Arrow.svg / ArrowBrand.svg). Inline SVG, тянется на ширину контейнера,
 * цвет наследуется через `currentColor` — переопределяется родителем
 * через CSS `color` или класс/проп. По умолчанию — текущий цвет текста.
 *
 * Используется как центральный логотип QR-кода (см. QRColumn), как
 * микро-иконка в footer Powered by, и т.д.
 *
 * @param {object} props
 * @param {string} [props.className] — дополнительный CSS класс.
 * @param {string} [props.title] — accessible title; если задан, иконка
 *   получает `role="img"` + `<title>`, иначе помечается `aria-hidden`.
 */
import './BrandArrowIcon.css';

export const BrandArrowIcon = ({ className, title }) => {
  const isDecorative = !title;
  return (
    <svg
      className={`brand-arrow-icon ${className || ''}`}
      viewBox="0 0 409 409"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={isDecorative ? undefined : 'img'}
      aria-hidden={isDecorative ? 'true' : undefined}
      aria-label={isDecorative ? undefined : title}
    >
      {title ? <title>{title}</title> : null}
      <path d="M408.944 0V409H373.039C333.312 409 301.107 376.783 301.107 337.042V184.185L76.2924 409L0 332.764L224.815 107.949H71.9317C32.205 107.949 0 75.7327 0 35.9915V0H409H408.944Z" />
    </svg>
  );
};
